import JSEncrypt from 'jsencrypt';

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCS3zBblzn5V9nKOet3qQLv2PfmYEWwVZwbU6' +
  'sxILdxWbaN2jHmS68uiFLBiMrh1pOX6IKTLnjdi5WgDCBjGN2DrR2HyswbVAnNi4FmC9c+AaMRd0ucy8E2A4SfIKEP+B+0qbw6ZiDfx' +
  'S55hlXLWDOYR0J+fMy8yf0fDSgF55AfmQIDAQAB';

const privateKey =
  'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAJLfMFuXOflX2co563epAu/Y9+ZgRbBVnBtTqzEgt3FZto3aMeZLry6IUsGIyuHWk5fogpMueN2LlaAMIGMY3YOtHYfKzBtUCc2LgWYL1z4BoxF3S5zLwTYDhJ8goQ/4H7SpvDpmIN/FLnmGVctYM5hHQn58zLzJ/R8NKAXnkB+ZAgMBAAECgYBnLQEUppTkc/GcXbnrssBMa9gib6klKc7jZ5CQj5Iuv749wnVhefOTtdKlAIq9wfanNYBdEr13rTIsX7h0xSf+4yLU3fqw31Ar4bDSU3xjoIEdvRn7bDwtMSFDBbT+Qh9aJNsrK7VqiJ/bbmWIVdsBV3DpVOHur3JvFLAL3sOXcQJBAMYuYTk5LzslZHNtGrrWx52r2CHiTVfllzfDIwNOsmGqTNV8WZP16kS0qLvqNReaaZm0geJuO4nnzSm4Hg4hqMUCQQC9uKbzWi2bAfxah2hbci3/t4KnOX+MughQ3byk9BT2G2QDcJUe91nB67jhDqlKElKGJsj5ka47kUb49KBPGEDFAkEAmteABRrF6Vt02a6kVNkdS/cJPqg3L/blqJ7hi2MAgshxkde/kZhxOs9AitoaM1/lJD/hv43LHRuss+z0Jqxr1QJBAI6rwcDXW9xpjeB2W6AJKVZYJkSjFKw7ae2GEkrp0qmQx5FepIV49WLDZXC5mc0+IhkIKbKkPyZEhd7J95QDZRECQD2DcnYS1iqvAeNzC1EvHaRb/tEZ5DzVvnXQuwpxmgOzka/qORlCoLQLSVoloNloS4A1PTy9y1akNYuMXUEqLNY=';

// 加密
export function encrypt(txt: string) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对数据进行加密
}

// 解密
export function decrypt(txt: string) {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(privateKey);
  return encryptor.decrypt(txt) || '';
}
